import { useEffect } from 'react';
import { MainApp } from '@wajeez-web/components/layouts';
import { addInitializer } from '@wajeez-web/core/types';
import { useRouting } from '@wajeez-web/components/helpers';
import { initializeAuth } from '@wajeez-web/modules/auth';
import {
  initializeContentNavigationSuperAdmin,
  initializeContentEndpointsSuperAdmin,
} from '@wajeez-web/modules/content';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useAuthSelector, AuthActions } from '@wajeez-web/stores/auth';
import {
  useCommonSelector,
  useCommonDispatch,
} from '@wajeez-web/stores/common';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const clientId =
  '28055906188-mp0vnuc1rvpdahh4eon01i9top95911t.apps.googleusercontent.com';

export default function App() {
  const dispatch = useCommonDispatch();

  const isAuthorized = useAuthSelector(
    (s) =>
      s.auth.token !== null && s.auth.token !== undefined && s.auth.token !== ''
  );
  const { permission } = useAuthSelector((state) => state.auth);

  const { dir } = useCommonSelector((state) => state.common.settings);

  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const theme = createTheme({
    direction: dir,
  });

  const { routes, endpoints } = useRouting([
    addInitializer('initializeAuth', 0, initializeAuth),
    addInitializer(
      'initializeContentNavigation',
      0,
      initializeContentNavigationSuperAdmin
    ),
    addInitializer(
      'initializeContentEndpoints',
      0,
      initializeContentEndpointsSuperAdmin
    ),
  ]);

  useEffect(() => {
    const url = endpoints.find((e) =>
      e.per.find((p) => permission?.includes(p))
    )?.endpoint;

    dispatch(AuthActions.initUrl(`/${url}`));
  }, [routes, endpoints]);

  useEffect(() => {
    document.body.setAttribute('dir', dir);
  }, [dir]);

  return (
    <div className="text-textPrimary font-tajwal hover:scrollbar-thumb-gray-700 scrollbar-track-transparent scrollbar-thin">
      <GoogleOAuthProvider clientId={clientId}>
        <ThemeProvider theme={theme}>
          {dir === 'rtl' ? (
            <CacheProvider value={cacheRtl}>
              <MainApp routes={routes} endpoints={endpoints} />
            </CacheProvider>
          ) : (
            <MainApp routes={routes} endpoints={endpoints} />
          )}
        </ThemeProvider>
      </GoogleOAuthProvider>
    </div>
  );
}
